import { formatDistance, format, differenceInYears } from "date-fns";
import { ptBR } from "date-fns/locale";

export const mesesExtenso = [
  "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
]
export const mesesExtenso3 = [
  "Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"
]
export const semanaExtenso = [
  "Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"
]
export const semanaAbrev3 = [
  "Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"
]
export const MesExtenso = mesId => mesesExtenso[mesId]
export const MesExtenso3 = mesId => mesesExtenso3[mesId]

export const hoje = () => {
  let hoje = new Date();
  let wd = hoje.getDay();
  let m = hoje.getMonth();
  return {
    diaSemana: wd,
    diaSemanaExtenso: semanaExtenso[wd],
    diaSemanaAbrev: semanaAbrev3[wd],
    dia: hoje.getDate(),
    mes: m + 1,
    mesExtenso: mesesExtenso[m],
    mesAbrev3: mesesExtenso3[m],
    ano: hoje.getFullYear(),
  }
}

export function sqlDataToJS(sqlD) {
  let [ ano, mes, dia ] = sqlD.split("-")
  mes = parseInt(mes) - 1;
  return new Date(ano,mes,dia);
}

export function distanciaAteHoje (date) {
  return formatDistance(
    date,
    new Date(),
    { locale: ptBR }
  )
}

export function formata (date, default_="") {
  if (!date) return default_;
  return format(
    date,
    'dd/MM/YYYY',
    { awareOfUnicodeTokens: true }
  )
}


/**
 * Get the number of days in any particular month
 * @link https://stackoverflow.com/a/1433119/1293256
 * @param  {integer} m The month (valid: 0-11)
 * @param  {integer} y The year
 * @return {integer}   The number of days in the month
 */
var daysInMonth = function (m, y) {
  switch (m) {
      case 1 :
          return (y % 4 == 0 && y % 100) || y % 400 == 0 ? 29 : 28;
      case 8 : case 3 : case 5 : case 10 :
          return 30;
      default :
          return 31
  }
};

/**
* Check if a date is valid
* @link https://stackoverflow.com/a/1433119/1293256
* @param  {[type]}  d The day
* @param  {[type]}  m The month
* @param  {[type]}  y The year
* @return {Boolean}   Returns true if valid
*/
export function isValidDate (d, m, y) {
  m = parseInt(m, 10) - 1;
  return m >= 0 && m < 12 && d > 0 && d <= daysInMonth(m, y);
};

export function contaAnos(date) {
  return differenceInYears(new Date(), date)
}
